import { MarkerPin03Icon } from "@/components/Icons/MarkerPin03Icon";
import { Inline } from "@/design-system/Inline";
import { Stack } from "@/design-system/Stack";
import { Text } from "@/design-system/Text";

import { DatedAnnouncementBadge } from "./DatedAnnouncementBadge";

export function DatedAnnouncementDetails({
  startsAt,
  endsAt,
  location,
  size = "lg",
}: {
  startsAt: Date | string;
  endsAt?: Date | string;
  location?: string;
  size?: "sm" | "lg";
}): React.ReactNode {
  return (
    <Stack gap="xs" align="start">
      <DatedAnnouncementBadge startsAt={startsAt} endsAt={endsAt} size={size} />
      {location && (
        <Inline gap="xs" align="center" wrap={false}>
          <MarkerPin03Icon size={16} tone="secondary" />
          <Text variant="caption" overflow="truncate">
            {location}
          </Text>
        </Inline>
      )}
    </Stack>
  );
}
